import React, { useState } from 'react';
import { Layout, Menu, Dropdown, Avatar, Space, Button } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  OrderedListOutlined,
  UserOutlined,
  CarOutlined,
  ShopOutlined,
  SettingOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/store';
import { logout } from '../store/slices/authSlice';

const { Header, Sider, Content } = Layout;

const AdminLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

  const menuItems = [
    {
      key: '/admin',
      icon: <DashboardOutlined />,
      label: 'ダッシュボード',
    },
    {
      key: '/admin/orders',
      icon: <OrderedListOutlined />,
      label: '注文管理',
    },
    {
      key: '/admin/users',
      icon: <UserOutlined />,
      label: 'ユーザー管理',
    },
    {
      key: '/admin/franchises',
      icon: <ShopOutlined />,
      label: 'フランチャイズ管理',
    },
    {
      key: '/admin/cars',
      icon: <CarOutlined />,
      label: '車両管理',
    },
    {
      key: '/admin/settings',
      icon: <SettingOutlined />,
      label: 'システム設定',
    },
  ];

  const handleMenuClick = (key: string) => {
    navigate(key);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const userMenu = (
    <Menu
      items={[
        {
          key: 'logout',
          icon: <LogoutOutlined />,
          label: 'ログアウト',
          onClick: handleLogout,
        },
      ]}
    />
  );

  // 临时移除认证检查，允许アクセス所有ページ进行演示
  // if (!isAuthenticated || user?.role !== 'admin') {
  //   navigate('/login');
  //   return null;
  // }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed} theme="light">
        <div className="logo" style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: collapsed ? 14 : 18, fontWeight: 'bold', color: '#1890ff' }}>
            {collapsed ? 'AES' : 'AES Admin'}
          </span>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => handleMenuClick(key)}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: '16px', width: 64, height: 64 }}
          />
          <div className="user-info" style={{ marginRight: 20 }}>
            <Dropdown overlay={userMenu} placement="bottomRight">
              <Space style={{ cursor: 'pointer' }}>
                <Avatar icon={<UserOutlined />} />
                <span>
                  {user?.profile?.firstName && user?.profile?.lastName 
                    ? `${user.profile.lastName} ${user.profile.firstName}`
                    : user?.email || '管理者'
                  }
                </span>
              </Space>
            </Dropdown>
          </div>
        </Header>
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;